/**
 * Defines the granularity options for csv export.
 */
export enum AnalyticsGranularity {
  All = 'all',
  Day = 'day',
}
